import './_blog-article-featured-products.scss';